import { graphql } from "@/graphql/generated/gql";

export const getInventoryValueQueryDocument = graphql(/* GraphQL */ `
  query GetInventoryValue($input: GetInventoryValueInput!) {
    inventoryValue(getInventoryValueInput: $input) {
      ...InventoryValueFields
    }
  }
`);

// NOTE: These mutations return the inventory object, not the inventory value object

export const deleteInventoryValueMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteInventoryValue($input: DeleteInventoryValueInput!) {
    deleteInventoryValue(deleteInventoryValueInput: $input) {
      status
      message
      inventoryId
      inventory {
        id
        workspaceId
        methodologyId
        title
        description
        year
        totalEnergyConsumption
        totalEmissions
        totalDataQuality
        inventoryValueList {
          ...InventoryValueFields
        }
        createdAt
        updatedAt
      }
    }
  }
`);

export const batchUpsertInventoryValueListMutationDocument = graphql(/* GraphQL */ `
  mutation BatchUpsertInventoryValueList($input: BatchUpsertInventoryValueListInput!) {
    batchUpsertInventoryValueList(batchUpsertInventoryValueListInput: $input) {
      status
      message
      inventoryId
      inventory {
        id
        workspaceId
        methodologyId
        title
        description
        year
        totalEnergyConsumption
        totalEmissions
        totalDataQuality
        inventoryValueList {
          ...InventoryValueFields
        }
        createdAt
        updatedAt
      }
    }
  }
`);

export const batchDeleteInventoryValueListMutationDocument = graphql(/* GraphQL */ `
  mutation BatchDeleteInventoryValueList($input: BatchDeleteInventoryValueListInput!) {
    batchDeleteInventoryValueList(batchDeleteInventoryValueListInput: $input) {
      status
      message
      inventoryId
      inventory {
        id
        workspaceId
        methodologyId
        title
        description
        year
        transportSourceMunicipalityIdList
        totalEnergyConsumption
        totalEmissions
        totalDataQuality
        inventoryValueList {
          ...InventoryValueFields
        }
        createdAt
        updatedAt
      }
    }
  }
`);

export const batchCommandsMutationDocument = graphql(/* GraphQL */ `
  mutation BatchCommands($input: BatchCommandsInput!) {
    batchCommands(batchCommandsInput: $input) {
      status
      message
      inventoryId
      inventory {
        id
        workspaceId
        methodologyId
        title
        description
        year
        totalEnergyConsumption
        totalEmissions
        totalDataQuality
        inventoryValueList {
          ...InventoryValueFields
        }
        createdAt
        updatedAt
      }
    }
  }
`);

export const populateTransportDataFromMunicipalityMutationDocument = graphql(/* GraphQL */ `
  mutation PopulateTransportDataFromMunicipality($inventoryId: String!, $municipalityIdList: [String!]!, $fillEmptyOnly: Boolean) {
    populateTransportDataFromMunicipality(inventoryId: $inventoryId, municipalityIdList: $municipalityIdList, fillEmptyOnly: $fillEmptyOnly) {
      id
      workspaceId
      methodologyId
      title
      description
      year
      totalEnergyConsumption
      totalEmissions
      totalDataQuality
      inventoryValueList {
        ...InventoryValueFields
      }
      createdAt
      updatedAt
    }
  }
`);

// The caller refetches the inventory detail afterwards, so selecting the value list here would pull
// the whole inventory twice per apply.
export const populateStationaryDefaultsFromNationalMutationDocument = graphql(/* GraphQL */ `
  mutation PopulateStationaryDefaultsFromNational($inventoryId: String!) {
    populateStationaryDefaultsFromNational(inventoryId: $inventoryId) {
      id
      workspaceId
    }
  }
`);
